import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { languageSelectorItemType } from './LanguageSelectorTypes';
import Vue from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSelectorItem',
  props: {
  dataItem: {
    type: Object as Vue.PropType<languageSelectorItemType>,
    default: null,
  },
  justifyContent: {
    type: String,
    default: 'left',
  },
  focused: Boolean,
  selected: Boolean,
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: "k-item",
    style: _normalizeStyle({ justifyContent: props.dataItem?.justify })
  }, _toDisplayString(props.dataItem?.text), 5))
}
}

})